import { apiClient } from '../../../../../../api';
import { ValidateAndUploadView } from '../../../../../../components/validate-upload-view/ValidateAndUploadView';
import { CreateSchedulesPreview } from '../common/CreateSchedulesPreview';
import { Station } from '@app/core/types/stations';

export function AudioSchedulesAscUpload({ station }: { station: Station }) {
  return (
    <ValidateAndUploadView
      allowedExtensions={['.asc']}
      validateFn={(file: File) =>
        apiClient.audit.ascParse({
          stationId: station.id,
          file: file!,
        })
      }
      importFn={(file, data) =>
        apiClient.audit.schedulesCreate({
          stationId: station.id,
          data,
        })
      }
      renderPreview={(data) => <CreateSchedulesPreview data={data} />}
    />
  );
}
